module.exports = __webpack_public_path__ + "assets/img/theme_bg.40e2a232.png";